export const cssBundleHref = "/build/css-bundle-H4PLRTN2.css";